<template>
	<section style="height: 100%;">
		<div class="col" style="height: 100%;">
			<div class="row" style="height: 100%;">
				<div class="col-lg-5">
					<ValidationObserver tag="form" v-slot="{ invalid }" onsubmit="return false" class="mx-auto col-lg-10">
						<h4 class="mb-4" style="margin-top: 150px;"><b>Ubah Kata Sandi</b></h4>
						
						<div class="alert alert-danger f-12" v-if="authFalse">
							Link reset kata sandi tidak valid, silakan gunakan link yang terbaru
						</div>

						<ValidationProvider name="Kata sandi baru" rules="required|min:8|alpha_num">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label">Kata sandi baru</label>
								<div class="input-group" id="show_hide_password" :class="{ 'error': errors[0] }">
									<input type="password" class="form-control append-button" placeholder="Masukkan kata sandi baru" v-model="password">
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="fa fa-eye-slash" aria-hidden="true"></i>
										</span>
									</div>
								</div>
								<div class="text-danger f-12 mt-2">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>

						<ValidationProvider name="Konfirmasi kata sandi" rules="required|confirmed:Kata sandi baru">
							<div class="form-group" slot-scope="{ errors }">
								<label class="form-label">Ulangi kata sandi</label>
								<div class="input-group" id="show_hide_password_confirm" :class="{ 'error': errors[0] }">
									<input type="password" class="form-control append-button" placeholder="Ulangi kata sandi baru" v-model="password_conf">
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="fa fa-eye-slash" aria-hidden="true"></i>
										</span>
									</div>
								</div>
								<div class="text-danger f-12 mt-2">{{ errors[0] }}</div>
							</div>
						</ValidationProvider>
						<button :disabled="invalid" @click="reset" class="btn btn-primary w-100 f-14 pd-10-20 mt-3">Kirim</button>
					</ValidationObserver>
				</div>
				<div class="d-none d-lg-block col-7"
					style="
						background-image: url('/img/login.png');
						background-color: #FFA827;
						background-repeat: round;
						height: 100%;
					">
					<div class="vertical-center" style="top:50%;">
						<img src="/img/login-1.png" alt="">
						<p class="text-white">Check every shipment easily</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data() {
        return {
            email: this.$route.query.email,
			token: this.$route.query.token,
			password: null,
			password_conf: null,
            authFalse: false
        }
    },
    methods: {
        reset() {
			let _ = this
            _.axios.post('/auth/reset_password', { email: _.email, password: _.password, token: _.token })
                .then(()=>{
                    this.$toast.open({
						message: 'Kata sandi baru berhasil dibuat',
						type: "success"
					})
                    _.$router.push('/login')
                })
                .catch(()=>{
                    _.authFalse = true
                })
		}
    },
	mounted() {
		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
	    });

	    $("#show_hide_password_confirm span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password_confirm input').attr("type") == "text"){
	            $('#show_hide_password_confirm input').attr('type', 'password');
	            $('#show_hide_password_confirm i').addClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password_confirm input').attr("type") == "password"){
	            $('#show_hide_password_confirm input').attr('type', 'text');
	            $('#show_hide_password_confirm i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').addClass( "fa-eye" );
	        }
	    });
	}
}
</script>